import { ExclusiveComponentsConstants } from '../exclusiveComponents/ExclusiveComponentsConstants';
import { v4 as uuid } from 'uuid';
export class ExclusiveComponentsService {
    static $inject = ['BuilderStateService', '$translate'];
    constructor(BuilderStateService, $translate) {
        'ngInject';
        this.BuilderStateService = BuilderStateService;
        this.$translate = $translate;
    }
    async createBlipChatCopyAndPaste() {
        return this.BuilderStateService.createBlipChatCopyAndPaste(await this.$translate('builder.exclusiveComponents.components.channels.blipChat.copyAndPaste.title'));
    }
    getBlipChatCopyAndPaste(state, onUpdate) {
        const oldContentActions = JSON.parse(state.$contentActions.find(action => action.action.settings.type === ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_TYPE).action.settings.rawContent);
        const blipChatCopyAndPaste = {
            document: {
                id: uuid(),
                type: ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_TYPE,
                content: {
                    body: oldContentActions.body,
                    button: {
                        text: oldContentActions.button.text,
                        value: oldContentActions.button.value,
                    },
                    footer: oldContentActions.footer,
                    header: oldContentActions.header,
                },
            },
            'on-save': onUpdate,
            'on-deleted': (_) => ({}),
            'on-metadata-edit': (_) => ({}),
            'on-open-link': () => ({}),
            editable: true,
            deletable: false,
            position: 'left',
            editing: false,
        };
        return blipChatCopyAndPaste;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
ExclusiveComponentsService.$inject = ['BuilderStateService', '$translate'];
